import FileUploadIcon from "../../assets/upload_file.svg";
import { Paper } from '@mui/material';
import FileInputWithDragAndDrop from './FileInputWithDragAndDrop';
import { ResourceTask } from "../../utils/tasks";

interface FileDropContainerProps {
    uploadTask: ResourceTask | undefined;
    onDropAccepted: (acceptedFiles: any) => void;
    onDropRejected: (rejectedFiles: any) => void;
}

const FileDropContainer = ({
  uploadTask,
  onDropAccepted,
  onDropRejected,
} : FileDropContainerProps) => {
return (
<Paper elevation={0} className='file-drop-wrapper'>
    <FileInputWithDragAndDrop
        className="cursorPointer"
        onDropAccepted={onDropAccepted}
        onDropRejected={onDropRejected}
        maxSize={15_728_640}
        placeholder="Upload File">
        {(isDragActive: any) => {
            return (
            <div className="fileDropContainer drop-zone-wrapper">
                <img src={FileUploadIcon} alt={"File upload icon"} />
                {!!uploadTask && (
                <span className='upload-label'>
                    Uploading...
                </span>
                )}
                {!uploadTask && (<>
                    <span className='upload-label'>
                        {isDragActive
                        ? "Drop your file"
                        : "Drag and drop document or click to browse for a file."}
                    </span>
                    <span className='upload-label-mobile'>
                        {isDragActive
                        ? "Drop your image"
                        : "Take a photo of your document or browse for your already stored image."}
                    </span>
                </>
                )}
            </div>
            );
        }}
    </FileInputWithDragAndDrop>
</Paper>
)
};

export default FileDropContainer;
